exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".snackbar-main {\r\n  font-family: 'montserrat_light', 'Segoe UI', arial, sans-serif;\r\n}\r\n.snackbar-main span {\r\n  padding-right: 24px;\r\n  font-size: 30px;\r\n  display: table-cell;\r\n  vertical-align: middle;\r\n}\r\n.snackbar-main p {\r\n  display: table-cell;\r\n  vertical-align: middle;\r\n}\r\n.snackbar-main span.ion-checkmark {\r\n  color: #39ca58;\r\n}\r\n.snackbar-main span.ion-close {\r\n  color: #ff4f2c;\r\n}\r\n.snackbar-main span.ion-alert {\r\n  color: #ffe916;\r\n}\r\n.snackbar-main span.ion-information {\r\n  color: #3db2ff;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/app/_shared/layout/custom-snackbar/custom-snackbar.component.css
// module id = ../../../../../src/app/_shared/layout/custom-snackbar/custom-snackbar.component.css
// module chunks = main